$(document).on('submit', "#register-form", function(e){
  e.preventDefault();

  $.ajax({
    url: $(this).attr('action'),
    data: $(this).serialize(),
    dataType: 'json',
    type: 'post',
    success: function(data){
      $('.text-danger').remove()
      if (data.code == 'error') {
        $.each(data.fields, function(key, value){
          if (key == 'terms') {
            $('label[for=terms]').after('<small class="text-danger d-block">'+value+'</small>');
          }else{
            $('input[name='+key+']').after('<small class="text-danger d-block">'+value+'</small>');            
          }
        })
      }else if (data.code == 'success') {
        $("#register-errors").html(data.fields)
        setTimeout(function(){
          location.reload()
        }, 2000)
      }
    }
  })
})

$(document).on('submit', "#login-form", function(e){
  e.preventDefault()

  $.ajax({
    url: $(this).attr('action'),
    data: $(this).serialize(),
    dataType: 'json',
    type: 'post',
    success: function(data){
      $('.text-danger').remove()
      $("#login-errors").html()
      if (data.code == 'error') {
        $.each(data.fields, function(key, value){
          $('input[name='+key+']').after('<small class="text-danger d-block">'+value+'</small>')
        })
      }else if (data.code == 'error_login') {
        $("#login-errors").html(data.fields)
      }else if (data.code == 'success') {
        $("#login-errors").html(data.fields)
        setTimeout(function(){
          location.reload()
        }, 2000)
      }
    }
  })
})

$(document).on("submit", ".fpw-form", function(e){
  e.preventDefault()

  $("#fpw-alerts").html('')
  $(".error-message").remove()
  $.ajax({
    url: $(this).attr("action"),
    data: $(this).serialize(),
    dataType: "json",
    type: "post",
    success: function(data){
      if (data.code == 'error') {
        $.each(data.fields, function(key, value){
          const error = `<span class="text-danger error-message">${value}</span>`;
          $('.fpw-form input[name='+key+']').after(error)
        })
      }
      else if (data.code == 'not_found') {
        $('#fpw-alerts').html(data.fields)
      }
      else{
        $('#fpw-alerts').html(data.fields)
        if (data.code == 'success') {
          setTimeout(function(){
            location.reload();
          }, 2000);
        }
      }
    }
  })

})
